import { render, staticRenderFns } from "./Localization.vue?vue&type=template&id=38278b58&"
import script from "./Localization.vue?vue&type=script&lang=js&"
export * from "./Localization.vue?vue&type=script&lang=js&"
import style0 from "./Localization.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports